import React, { useRef } from 'react';
import * as MenuListUI from 'components/MenuList';
import { useComboboxContext } from './Combobox';
function ComboboxMenuItem(_ref) {
  var value = _ref.value,
    text = _ref.text,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    children = _ref.children;
  var itemRef = useRef(null);
  var _useComboboxContext = useComboboxContext(),
    itemList = _useComboboxContext.itemList;
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      value: value !== null && value !== void 0 ? value : children,
      text: text || (typeof children === 'string' ? children : undefined),
      disabled: isDisabled
    }),
    id = _itemList$useItem.id,
    select = _itemList$useItem.select,
    selected = _itemList$useItem.selected,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  return /*#__PURE__*/React.createElement(MenuListUI.Item, {
    ref: itemRef,
    id: id,
    role: "option",
    "aria-selected": selected,
    "aria-disabled": isDisabled,
    onClick: select,
    onMouseEnter: highlight,
    onMouseLeave: itemList.clearHighlightedItem
  }, /*#__PURE__*/React.createElement(MenuListUI.Link, {
    forwardedAs: "span",
    isActive: selected,
    isDisabled: isDisabled,
    isHighlighted: useHighlighted()
  }, icon && /*#__PURE__*/React.createElement(MenuListUI.ItemIcon, {
    name: icon
  }), children));
}
export default ComboboxMenuItem;